import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const planData = (id?: string, response?: any, planTypes?: any): FormProps[] => {

    const data: FormProps[] = [
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Nome*',
            value: id ? response?.name : null,
            name: 'name',
            rules: {
                required: 'O nome do plano é obrigatório'
            },
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Quantidade de projetos*',
            value: id ? response?.quantityProjects : null,
            name: 'quantityProjects',
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Tipo de plano*',
            value: id ? response?.planTypeId : null,
            name: 'planTypeId',
            rules: {
                required: 'O tipo de plano é obrigatório'
            },
            options: {
                placeholder: 'Tipo de plano',
                data: planTypes,
                value: id ? response?.planTypeId : null
            }
        },
        {
            typeOfField: FormTypes.CURRENCY,
            type: 'text',
            placeholder: 'Preço*',
            value: id ? response?.price : null,
            name: 'price',
            rules: {
                required: 'O preço do plano é obrigatório'
            },
            width: 740,
            height: 55
        },
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Descrição*',
            value: id ? response?.description : null,
            name: 'description',
            rules: {
                required: 'A descrição do plano é obrigatória'
            },
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.CHECKBOX,
            type: 'text',
            placeholder: 'É ilimitado?',
            label: 'É ilimitado?',
            value: id ? response?.isUnlimited : null,
            name: 'isUnlimited',
            width: 740,
            height: 55,
        }
    ];

    return data;
};

export default planData;